import React from "react";
import { Shield, User, Lock, Mail } from "lucide-react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#e5e7eb] px-6 py-12 flex flex-col items-center">
      {/* Heading */}
      <h1 className="text-5xl font-bold text-[#111827] mb-6">
        Privacy Policy
      </h1>
      <p className="text-lg text-[#374151] max-w-3xl text-center mb-12">
        At <span className="font-semibold">Campus Canteen</span>, we respect
        your privacy. This Privacy Policy explains how we handle your
        information when you order food through our application.
      </p>

      {/* Sections */}
      <div className="max-w-4xl w-full space-y-8">
        {/* Information Collection */}
        <div className="bg-white p-6 rounded-2xl shadow-lg">
          <div className="flex items-center mb-4">
            <User className="w-6 h-6 text-[#111827] mr-2" />
            <h2 className="text-2xl font-semibold text-[#111827]">
              Information We Collect
            </h2>
          </div>
          <p className="text-[#4b5563]">
            We collect basic details such as your name, phone number, email
            address, and order preferences to provide a smooth ordering
            experience. We do not collect unnecessary personal data.
          </p>
        </div>

        {/* Use of Information */}
        <div className="bg-white p-6 rounded-2xl shadow-lg">
          <div className="flex items-center mb-4">
            <Shield className="w-6 h-6 text-[#111827] mr-2" />
            <h2 className="text-2xl font-semibold text-[#111827]">
              How We Use Your Information
            </h2>
          </div>
          <p className="text-[#4b5563]">
            Your information is used only to process orders, communicate with
            you about updates, and improve our canteen services. We never sell
            your data to third parties.
          </p>
        </div>

        {/* Data Protection */}
        <div className="bg-white p-6 rounded-2xl shadow-lg">
          <div className="flex items-center mb-4">
            <Lock className="w-6 h-6 text-[#111827] mr-2" />
            <h2 className="text-2xl font-semibold text-[#111827]">
              Data Protection
            </h2>
          </div>
          <p className="text-[#4b5563]">
            We implement appropriate security measures to protect your personal
            data. Access to your information is limited only to authorized
            personnel involved in order processing.
          </p>
        </div>

        {/* Contact */}
        <div className="bg-white p-6 rounded-2xl shadow-lg">
          <div className="flex items-center mb-4">
            <Mail className="w-6 h-6 text-[#111827] mr-2" />
            <h2 className="text-2xl font-semibold text-[#111827]">
              Contact Us
            </h2>
          </div>
          <p className="text-[#4b5563]">
            If you have any questions regarding this Privacy Policy, please
            contact us at: <br />
            <span className="font-medium">grabgrubcontact@gmail.com</span>
          </p>
        </div>
      </div>

      {/* Closing Note */}
      <p className="mt-12 text-[#374151] text-center max-w-2xl">
        By using our application, you agree to this Privacy Policy. We may
        update it from time to time to reflect changes in our practices.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
